import { defineComponent as _defineComponent } from 'vue'
import CustomizeHouseSlider from "@/components/builder/CustomizeHouseSlider.vue";
  import { StyleOption } from "@/types/BuilderEstimatorStyleOption";
  import { formatPrice } from "@/helpers/transformation/price";
  import { watch } from "vue";
  interface Props {
    sliderOptions: StyleOption[];
    instructions: {
      title: string;
      description: string;
    };
    selectedStyle: StyleOption | null;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderEstimatorSelectionHouseMobile',
  props: {
    sliderOptions: {},
    instructions: {},
    selectedStyle: {}
  },
  emits: ["onSelectOptionStyle"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;

  const onSelectOptionStyle = (option: StyleOption) => {
    emits("onSelectOptionStyle", option);
  };

const __returned__ = { props, emits, onSelectOptionStyle, CustomizeHouseSlider, get StyleOption() { return StyleOption }, get formatPrice() { return formatPrice }, watch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})